module.exports = __webpack_public_path__ + "img/bch.274d44f0.svg";